import { BrowserRouter } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import MainContent from "./components/MainContent";
import Section from "./components/Section";
import SectionContainer from "./components/SectionContainer";
import Sidebar from "./components/Sidebar";
import Tools from "./components/Tools";
import WorkCard from "./components/WorkCard";

import FoodAppImgMid from "./assets/Food-App-mid.png";
import MernImgMid from "./assets/MERN-mid.png";
import NexterImgMid from "./assets/Nexter-mid.png";
import NatoursImgMid from "./assets/Natours-mid.png";

import "./css/style.css";

const Mern = MernImgMid;
const Nexter = NexterImgMid;
const FoodApp = FoodAppImgMid;
const Natours = NatoursImgMid;

const WorkArray = [
  {
    key: '01',
    title: 'MERN Places project',
    subtitle:
      'Fully functional. Images loaded will only be stored for 30 minutes.',
    tools: [
      'MongoDB',
      'Express',
      'React',
      'NodeJS',
      'OpenStreetMaps',
      'Leaflet',
    ],
    githubFront: 'https://github.com/JuanK81/mern-frontend',
    githubBack: 'https://github.com/JuanK81/mern-2',
    site: 'https://kdev-mern-project.web.app/',
    img: Mern,
  },
  {
    key: '02',
    title: 'Nexter Sass project',
    subtitle: 'Just layout, non functional.',
    tools: ['HTML', 'CSS', 'SASS'],
    githubFront: 'https://github.com/JuanK81/advanced-css-nexter',
    site: 'https://confident-noyce-1457f4.netlify.app/',
    img: Nexter,
  },
  {
    key: '03',
    title: 'Natours Sass Project',
    subtitle: 'Just layout, non functional.',
    tools: ['HTML', 'CSS', 'SASS'],
    githubFront: 'https://github.com/JuanK81/advanced-css-natours',
    site: 'https://pensive-goldwasser-50ccee.netlify.app/',
    img: Natours,
  },
  {
    key: '04',
    title: 'Food Order App React project',
    subtitle:
      'Fully functional. I will get your order but no food will be delivered, sorry.',
    tools: ['React', 'FireBase'],
    githubFront: 'https://github.com/JuanK81/FoodOrderApp',
    site: 'https://jk-react-meals-app.netlify.app/',
    img: FoodApp,
  },
];

function App() {
  const loadedTools = WorkArray.map((item) => {
    return (
      <WorkCard
        key={item.key}
        title={item.title}
        subtitle={item.subtitle}
        tools={item.tools.map((tool) => (
          <p key={tool}>{tool}</p>
        ))}
        githubFront={item.githubFront}
        githubBack={item.githubBack}
        site={item.site}
        img={item.img}
      />
    );
  });

  return (
    <>
      <BrowserRouter>
        <Sidebar>
          <li className="navigation__item">
            <HashLink className="navigation__link" to="/#" smooth="true">
              HOME
            </HashLink>
          </li>
          <li className="navigation__item">
            <HashLink className="navigation__link" to="/#work" smooth="true">
              WORK
            </HashLink>
          </li>
          <li className="navigation__item">
            <HashLink className="navigation__link" to="/#toolbox" smooth="true">
              TOOLBOX
            </HashLink>
          </li>
          <li className="navigation__item">
            <HashLink className="navigation__link" to="/#about" smooth="true">
              ABOUT
            </HashLink>
          </li>
          <li className="navigation__item">
            <HashLink className="navigation__link" to="/#contact" smooth="true">
              CONTACT
            </HashLink>
          </li>
        </Sidebar>

        <MainContent>
          <Hero id="/" />

          <Section id="work" title="work">
            <SectionContainer>{loadedTools}</SectionContainer>
          </Section>

          <Section id="toolbox" title="toolbox">
            <Tools />
          </Section>

          <Section id="about" title="about">
            <p className="about__text">
              Junior <span className="about__text--span">front-end</span>{" "}
              developer,{" "}
              <span className="about__text--span">curious and thoughtful</span>,
              used to working with people in various professional settings and
              with the ability to apply skills from different fields to solve
              challenges. I'm here to{" "}
              <span className="about__text--span">learn and grow</span>.
            </p>
          </Section>

          <Section id="contact" title="contact">
            <Contact />
          </Section>
        <Footer />
        </MainContent>
      </BrowserRouter>
    </>
  );
}

export default App;
